import { ListPICShuttledRequest } from "@/domain/entities/ReconcileCod";

export class ReconcileCodEndpoints {
  getListPICShuttle(params: ListPICShuttledRequest) {
    return `/hydra/v2/dashboard-delivery/pic-list/cod?${params.toQueryString()}`;
  }
}
